<style></style>
<template>
  <div class="creatPassageway-box">
    <div class="shade-box">
      <div class="shade-content position-top">
        <p class="dialog-title-bg">{{title}}
          <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="resetPassagewayForm('creatPassagewayForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="creatForm" :rules="$rules" ref="creatPassagewayForm" label-width="130px" class="demo-ruleForm">
            <el-form-item label="通道名称">
              <el-input v-model="creatForm.smsPlatformName" disabled></el-input>
            </el-form-item>
            <el-form-item label="短信余额">
              <el-input v-model="creatForm.smsBanlance" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item label="通道类型" prop="platformType">
              <el-input v-model="creatForm.platformType" placeholder="请输入通道类型"></el-input>
            </el-form-item> -->
            <el-form-item label="使用优先级" prop="priorLevel">
              <el-input v-model="creatForm.priorLevel" placeholder="请输入通道使用优先级" maxlength="5"></el-input>
            </el-form-item>
            <el-form-item label="充值类型" prop="changeType">
              <el-radio-group v-model="changeType">
                <el-radio :label="1">短信</el-radio>
                <el-radio :label="2">富信</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="短信变动额度(条)" prop="overplus">
              <el-radio v-model="overplusStatus" label="1">增加</el-radio>
              <el-radio v-model="overplusStatus" label="2">减少</el-radio>
              <el-input v-model="creatForm.overplus" placeholder="请输入变动值" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('creatPassagewayForm')" :disabled="disabled">确认修改</el-button>
              <el-button @click="resetPassagewayForm('creatPassagewayForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  props: {
    data:{
      type: Object
    }
  },
  name: "creatPassageway",
  data(){
    return{
      disabled: false,
      title: '修改短信变动和使用优先级',
      overplusStatus: '1',
      changeType : 1,
      creatForm: {
        // smsPlatformName: '',
        // platformType: '',
        priorLevel: '',
        overplus: ''
      },
    };
  },
  created(){
    if(this.data){
      this.creatForm = this.data;
    }
  },
  methods: {
    submitForm(formName){//修改
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          if(this.overplusStatus == '1'){
            this.creatForm.overplus = '+' + this.creatForm.overplus;
          }else{
            this.creatForm.overplus = '-' + this.creatForm.overplus;
          }
          let data = {
            // "smsPlatformName": this.creatForm.smsPlatformName,
            // "platformType": this.creatForm.platformType,
            "priorLevel": this.creatForm.priorLevel,
            "overplus": this.creatForm.overplus,
            "changeType": this.changeType,
            "id": this.creatForm.id
          }
          api.Update({data:data}).then(res => {
            if(res.status == 'success'){
              this.$message.success(res.msg)
              this.$emit('passagewayClose')
            }else{
              this.disabled = false;
            }
          })
        } else {
          return false;
        }
      });
    },
    resetPassagewayForm(formName){//取消
      this.$refs[formName].resetFields();
      this.$emit('passagewayClose')
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/passageway/creatPassageway.vue